import React, { Component } from "react";
import styled from "styled-components";
import { Menu, MenuItem } from 'react-aria-menubutton';

import CheckImage from '../images/check.png';

const MenuContainer = styled.span`
    div[role=menu] {
        display: block;
        position: absolute;
        z-index: 3;

        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        box-shadow: 0 1px 4px 0 rgba(0,0,0,0.50);
        border-radius: 2px;

        :before, :after {
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        
        :before {
            border-width: 10px;
        }
        
        :after {
            border-width: 8px;
        }
        
        &.left {
            top: 50%;
            left: -10px;
            transform: translate(-100%, -50%);
        }
        
        &.left:before, &.left:after {
            left: 100%;
            top: 50%;
        }
        
        &.left::before {
            border-left-color: lightgrey;
            margin-top: -10px;
        }
        
        &.left::after {
            border-left-color: white;
            margin-top: -8px;
        }

        &.up {
            top: -10px;
            left: 50%;
            transform: translate(-50%, -100%);
        }

        &.up:before, &.up:after {
            top: 100%;
            left: 50%;
        }
    
        &.up::before {
            border-top-color: lightgrey;
            margin-left: -10px;
        }
    
        &.up::after {
            border-top-color: white;
            margin-left: -8px;
        }

        &.down:before, &.down:after {
            bottom: 100%;
            left: 50%;
        }
    
        &.down::before {
            border-bottom-color: lightgrey;
            margin-left: -10px;
        }
    
        &.down::after {
            border-bottom-color: white;
            margin-left: -8px;
        }

        > ul {
            padding: 0;
            margin: 0;
            list-style-type: none;
        
        
            > li {
                width: auto;
                text-align: left;
                padding: 16px 21px 16px 21px;
                border-bottom: 1px solid #DDDDDD;
        
                > div[role=menuitem] {
                    font-family: Lato-Regular;
                    font-size: 14px;
                    font-weight: normal;
                    color: #2B2B2B;
                    text-decoration: none;
                    line-height: 17px;

                    &.selected:after {
                        content: url(${CheckImage});
                        float: right;
                    }
                }
            }

            > li:hover {
                background-color: #e5f8ed;
                cursor: pointer;
            }

            > li:active {
                background-color: #00B550;

                > div[role=menuitem] {
                    color: white;
                    outline: none;
                }
            }
        
            > li:last-child {
                border-bottom: 0;
            }

        }
    }
`

class BubbleMenu extends Component {

    onOptionClicked(key) {
        if(this.props.onOptionClicked != null) {
            this.props.onOptionClicked(key);
        }
    }

    render() {
        const options = this.props.options ? this.props.options : null;
        const selectedValue = this.props.selectedValue

        return (
            <MenuContainer className="bubble-menu-container">
                <Menu className={this.props.arrow}>
                    <ul>
                        {options.map((el, index) => {
                            return (
                                <li key={index}>
                                    <MenuItem value={el.value} className={selectedValue === el.value ? 'selected' : ''}>
                                        {el.label}
                                    </MenuItem>
                                </li>
                            )
                        })}
                    </ul>
                </Menu>
            </MenuContainer>
        );
    }
}

export default BubbleMenu;
